import { Platform } from 'react-native'
import type { Theme } from '../../theme/getTheme'

export const getChallengesEmptyStateStyleSheet = (theme: Theme) => ({
  emptyContainer: {
    flex: 1,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    padding: 20,
  },
  emptyArenaTitle: {
    fontSize: 22,
    fontWeight: '700' as const,
    color: theme.black,
    marginTop: 4,
    marginBottom: 8,
    textAlign: 'center' as const,
  },
  emptyArenaSubtitle: {
    fontSize: 16,
    fontWeight: '400' as const,
    color: theme.gray[600],
    textAlign: 'center' as const,
    lineHeight: 24,
    marginBottom: 24,
    maxWidth: 300,
    alignSelf: 'center' as const,
  },
  emptyFilteredWrapper: {
    flex: 1,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    paddingHorizontal: 32,
    paddingVertical: 48,
    minHeight: 280,
  },
  emptyFilteredIconWrap: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: theme.primaryLight
      ? `${theme.primaryLight}25`
      : theme.gray[200],
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    marginBottom: 20,
  },
  emptyFilteredIcon: {
    marginBottom: 0,
  },
  emptyFilteredTitle: {
    fontSize: 18,
    fontWeight: '700' as const,
    color: theme.black,
    textAlign: 'center' as const,
    marginBottom: 8,
  },
  emptyFilteredSubtitle: {
    fontSize: 15,
    fontWeight: '400' as const,
    color: theme.gray[600],
    textAlign: 'center' as const,
    lineHeight: 22,
    maxWidth: 260,
  },
  emptyActionButton: {
    backgroundColor: theme.primary,
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 24,
    marginTop: 16,
    borderWidth: 2,
    borderColor: theme.primaryDark || theme.gray[300],
    ...(Platform.OS === 'web' && {
      boxShadow: theme.shadows.button,
    }),
  },
  emptyActionButtonPressed: { opacity: 0.8 },
  emptyActionButtonHover: { opacity: 0.9 },
  emptyActionButtonText: {
    fontSize: 16,
    fontWeight: '600' as const,
    color: theme.white,
  },
  challengesListContentEmpty: {
    flexGrow: 1,
    justifyContent: 'center' as const,
    // Keep the empty-state CTA clear of the tab bar (+ home indicator on iOS).
    paddingBottom: Platform.OS === 'web' ? 24 : 100,
  },
  challengesListContentFilteredEmpty: {
    flexGrow: 1,
  },
  challengesListContentWithItems: {
    paddingBottom: 24,
  },
})
